@for (item of items; track item) {
  <div class="folder-grid-item float-start d-flex flex-column align-items-center justify-content-center text-center"
    [id]="'grid_' + item.id"
    [ngClass]="{'cursor-pointer': item.isFolder || !isExportMode, 'selected': isFileSelected(item.id)}"
    (click)="onItemClick(item)">
    @if (!item.isFolder && !isExportMode) {
      <input
        id="checkbox_{{item.id}}"
        (click)="$event.stopPropagation()"
        [checked]="isFileSelected(item.id)"
        (change)="onCheckboxChange($event, item)"
        type="checkbox"
        class="file-checkbox">
    }
    <div>
      @if (item.isFolder) {
        <i class="gridViewIcon bi bi-folder-fill bi-large mb-1"></i>
      }
      @if (!item.isFolder) {
        <i class="gridViewIcon bi bi-large mb-1" [class]="getFileIcon(item.name)"></i>
      }
      <span [ngClass]="{'cursor-pointer': item.isFolder || !isExportMode}" class="px-2 folderName mt-1">
        {{item.name}}
      </span>
    </div>
  </div>
}
